"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var global_1 = require("./global");
var components_1 = require("./components");
var themeOptions = (0, styles_1.createTheme)({
    breakpoints: global_1.breakpoints,
    palette: global_1.palette,
    shape: global_1.shape,
    spacing: global_1.spacing,
    typography: global_1.typography,
});
themeOptions.components = (0, components_1.createComponents)(themeOptions);
exports.default = themeOptions;
//# sourceMappingURL=index.js.map